import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "caret"]

  connect() {
    this.boundClose = this.close.bind(this)
    this.boundCloseAll = this.closeAll.bind(this)
    document.addEventListener("click", this.boundClose)
    document.addEventListener("dropdown:closeAll", this.boundCloseAll)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
    document.removeEventListener("dropdown:closeAll", this.boundCloseAll)
  }

  toggle(event) {
    event.stopPropagation()

    const closeEvent = new CustomEvent("dropdown:closeAll", {
      bubbles: true,
      detail: { origin: this.element }
    })
    document.dispatchEvent(closeEvent)

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.menuTarget.classList.remove("scale-95", "opacity-0")
      this.menuTarget.classList.add("scale-100", "opacity-100")
    })
    if (this.hasCaretTarget) {
      this.caretTarget.classList.add("rotate-180") // on open
    }
  }

  close(event) {
    if (!event || !this.element.contains(event.target)) {
      this.menuTarget.classList.remove("scale-100", "opacity-100")
      this.menuTarget.classList.add("scale-95", "opacity-0")
      if (this.hasCaretTarget) {
        this.caretTarget.classList.remove("rotate-180") // on close
      }
      setTimeout(() => {
        this.menuTarget.classList.add("hidden")
      }, 200) // Match Tailwind duration
    }
  }

  closeAll(event) {
    const origin = event.detail?.origin
    if (this.element !== origin) {
      this.close()
    }
  }
}
